import React, { useContext } from 'react';
import './style.scss';
import { Accordion, AccordionContext, useAccordionToggle } from 'react-bootstrap';
import icons from '../../../../../common/Icons.js';
import clsx from 'clsx';
import AppHeaderMenuSectionAccordion from './section/index.js';
import { Link, Text } from '@sitecore-jss/sitecore-jss-react';

const AppHeaderMenuAccordion = ({ items }) => (
  <Accordion className="app-header-menu-accordion">
    {items.map((item, index) => (
      <MenuItem data={item.fields} key={index} id={index + 1} />
    ))}
  </Accordion>
);

const MenuItem = ({ data, id }) => {
  const hasData = data?.items?.length > 0;
  const isActive = useContext(AccordionContext) === id;
  const onClick = useAccordionToggle(id);

  return (
    <div className={clsx('ah-ma-item', isActive && hasData && 'ah-ma-item-active')}>
      <div className="ah-ma-item-front" onClick={onClick}>
        <MenuItemTitle title={data?.title} link={data?.link} hasNested={hasData} />
        {hasData && <img src={icons.chevronDown} className="ah-ma-item-arrow" />}
      </div>
      {hasData && (
        <Accordion.Collapse eventKey={id}>
          <AppHeaderMenuSectionAccordion data={data?.items} />
        </Accordion.Collapse>
      )}
    </div>
  );
};

const MenuItemTitle = ({ link, title, hasNested }) => {
  if (!link?.value?.href) {
    return (
      <div className="ah-ma-item-front-title">
        <Text field={title} />
      </div>
    );
  }
  if (!hasNested) {
    return (
      <Link field={link} className="ah-ma-item-front-title">
        <Text field={title} />
      </Link>
    );
  }
  return (
    <div className="ah-ma-item-front-title">
      <Link
        field={link}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Text field={title} />
      </Link>
    </div>
  );
};

export default AppHeaderMenuAccordion;
